import { useMemo, useState } from 'react'
import { navigate } from './App.jsx'

// La page d'accueil est une pile de blocs que la mairie ordonne elle-même
// depuis son back-office. Ici on se contente de les rendre dans l'ordre reçu.
export default function Home({ site }) {
  const [q, setQ] = useState('')
  const blocks = (site.blocks || []).filter((b) => b.on)
  const hero = blocks.find((b) => b.type === 'hero')

  const trouves = useMemo(() => {
    if (!q.trim()) return null
    const n = q.toLowerCase()
    return site.forms.filter((f) =>
      (f.title + ' ' + f.description + ' ' + f.category).toLowerCase().includes(n))
  }, [q, site.forms])

  const parCategorie = useMemo(() => {
    const out = {}
    for (const f of site.forms) (out[f.category] ||= []).push(f)
    return out
  }, [site.forms])

  return (
    <>
      {hero && (
        <section className={`hero ${site.theme.banner || 'aplat'}`}>
          <div className="in">
            <h1>{hero.title}</h1>
            <p>{hero.lede}</p>
          </div>
        </section>
      )}

      <div className="wrap">
        {blocks.map((b) => {
          if (b.type === 'hero') return null
          if (b.type === 'alerte') return (
            <div className="alerte" role="status" key={b.id}>{b.text}</div>
          )
          if (b.type === 'search') return (
            <div className="recherche" key={b.id}>
              <label htmlFor="q" className="sr">Rechercher une démarche</label>
              <input id="q" type="search" value={q} onChange={(e) => setQ(e.target.value)}
                     placeholder="Que cherchez-vous ? acte, école, encombrants…" />
            </div>
          )
          if (trouves) return null
          if (b.type === 'popular') {
            const mis = site.forms.filter((f) => f.featured).slice(0, b.n || 6)
            const list = mis.length ? mis : site.forms.slice(0, b.n || 6)
            return (
              <section key={b.id}>
                <h2>{b.title || 'Les plus demandées'}</h2>
                <div className="raccourcis">
                  {list.map((f) => (
                    <button key={f.slug} onClick={() => navigate(`/demarche/${f.slug}`)}>
                      {f.title}
                    </button>
                  ))}
                </div>
              </section>
            )
          }
          if (b.type === 'categories') return (
            <section key={b.id}>
              <h2>{b.title || 'Toutes les démarches'}</h2>
              {Object.entries(parCategorie).map(([cat, forms]) => (
                <div key={cat} className="categorie">
                  <h3>{cat}</h3>
                  <Cartes forms={forms} />
                </div>
              ))}
            </section>
          )
          if (b.type === 'suivi') return (
            <section className="encart" key={b.id}>
              <div>
                <h2>Une demande déjà déposée ?</h2>
                <p>Retrouvez son avancement, les messages du service et les pièces à fournir.</p>
              </div>
              <button className="btn pri" onClick={() => navigate('/suivi')}>Suivre ma demande</button>
            </section>
          )
          if (b.type === 'infos') return (
            <section className="infos" key={b.id}>
              <div><h3>Horaires</h3><p>{site.contact.horaires}</p></div>
              <div><h3>Nous joindre</h3><p>{site.contact.tel}<br />{site.contact.mail}</p></div>
              <div><h3>Adresse</h3><p>{site.contact.adresse}</p></div>
            </section>
          )
          return null
        })}

        {trouves && (
          <section>
            <h2>{trouves.length} résultat{trouves.length > 1 ? 's' : ''}</h2>
            <Cartes forms={trouves} />
          </section>
        )}
      </div>
    </>
  )
}

function Cartes({ forms }) {
  return (
    <div className="cartes">
      {forms.map((f) => (
        <article className="carte" key={f.slug}>
          <p className="cat">{f.category}</p>
          <h3><a href={`/demarche/${f.slug}`}
                 onClick={(e) => { e.preventDefault(); navigate(`/demarche/${f.slug}`) }}>
            {f.title}
          </a></h3>
          <p>{f.description}</p>
          <span className="go" aria-hidden="true">Commencer →</span>
        </article>
      ))}
    </div>
  )
}
